import dayjs from "dayjs";
import BaseValidator from "./Base";

export default class BirthDateValidator extends BaseValidator {
    private todayDate;
    private minYear;
    private format;

    constructor(name: string, message: string, format: string, minYear: number) {
        super(name, message);
        this.todayDate = dayjs().hour(0).minute(0).second(0).millisecond(0);
        this.format = format;
        this.minYear = minYear;
    }

    isNotValid(value: any): boolean {
        const valueDate = dayjs(value);
        const FormatValidation = valueDate.format(this.format) === value;
        const maxDateValidation = this.todayDate.diff(valueDate, "day") > 0;
        const minYearValidation = valueDate.year() >= this.minYear;
        
        return !FormatValidation || !maxDateValidation || !minYearValidation;
    }
}
